import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';

@Directive({
  selector: '[appPhoneMatch]',
  providers: [{provide: NG_VALIDATORS, useExisting: PhoneMatchDirective, multi: true}],
  standalone: false
})
export class PhoneMatchDirective implements Validator {

  constructor() { }

  validate(control: AbstractControl): any {
    
    const comp1=control.get('mobilePhone');
    const comp2=control.get('verifyMobile');
    if(comp1 && comp2){
      
      let kys1= Object.keys(comp1.value); let kys2= Object.keys(comp2.value);
      if(kys1.length===kys2.length){
        for(let i=0; i<kys1.length; i++){
          let v1=comp1.value[kys1[i]]; let v2=comp2.value[kys2[i]];
          //if(v1 && v2){
            let subComp=comp2.get(kys2[i]);
            if(v1 !== v2){
              subComp?.setErrors({phoneVerify:true});
            }else{
              subComp?.updateValueAndValidity({onlySelf: true, emitEvent: false});
            }
          //}
        }
      }
    
    }

    return null;
  }

}
